import * as React from "react";
export const withContext = contexts => Component => {
    const reduced = Object.keys(contexts).reduce((Prev, current) => {
        const Context = contexts[current];
        return props => {
            return (React.createElement(Context.Consumer, null, value => {
                const config = { [current]: value };
                return React.createElement(Prev, Object.assign({}, props, config));
            }));
        };
    }, Component);
    return reduced;
};
//# sourceMappingURL=withContext.js.map